// 首页底部「一言」句子库（格式：{ hitokoto: 句子, from: 出处 }）
// 想换 / 增删句子，直接改这个数组即可，格式照抄，from 会显示成「——《出处》」
export default [
	// 哈利·波特
	{ hitokoto: '决定我们是什么人的，不是我们的能力，而是我们的选择。', from: '哈利·波特' },
	{ hitokoto: '沉湎于虚幻的梦想，而忘记现实的生活，是毫无益处的。', from: '哈利·波特' },
	{ hitokoto: '一个人的出身并不重要，重要的是他成长为什么样的人。', from: '哈利·波特' },
	{ hitokoto: '不要怜悯死者，怜悯活人，尤其是那些在没有爱的情况下活着的人。', from: '哈利·波特' },
	// 头号玩家
	{ hitokoto: '现实才是唯一真实的东西。', from: '头号玩家' },
	{ hitokoto: '谢谢你玩我的游戏。', from: '头号玩家' },
	// 鬼灭之刃
	{ hitokoto: '纵使是再软弱的人，也有想要守护的东西。', from: '鬼灭之刃' },
	{ hitokoto: '只要还有一丝希望，就不要轻言放弃。', from: '鬼灭之刃' },
	{ hitokoto: '即使再痛苦，也要努力活下去。', from: '鬼灭之刃' },
	// 罗小黑战记
	{ hitokoto: '无论走多远，有你在的地方，就是家。', from: '罗小黑战记' },
	{ hitokoto: '从今天起，你就是我的徒弟了。', from: '罗小黑战记' },
	// 杀死伊芙
	{ hitokoto: '你是我唯一想靠近的人，也是我唯一想远离的人。', from: '杀死伊芙' },
	{ hitokoto: '别装作不了解我，你比谁都懂我。', from: '杀死伊芙' },
]
